

import FAQ3 from "../components/FAQ3";
import Footer from "../components/Footer";
import Header from "../components/Header";

function CruiseTransfers() {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog12.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Cruise Transfers
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Cruise Transfers</span>
          </div>
        </div>
      </div>
    </section>

       <section className="bg-white py-10 sm:py-10 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Cruise Terminal Limo and Car Service" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Cruise Terminal Limo and Car Service
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Looking for dependable cruise terminal limo and car service in NYC? We provide luxury, punctual, and stress-free cruise terminal transportation to and from all major New York cruise ports. Whether you're departing for a vacation or returning from a cruise, our professional chauffeurs ensure smooth and comfortable transportation to New York cruise ports.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Avoid traffic, parking hassles, and unreliable ride-shares travel with confidence and arrive relaxed.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Premium Transportation to New York Cruise Ports
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          We specialize in transportation to New York cruise ports, including:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Manhattan Cruise Terminal</strong> (Pier 88, 90, 92)</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Brooklyn Cruise Terminal</strong> (Red Hook)</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Cape Liberty Cruise Port</strong> (Bayonne, NJ)</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our chauffeurs monitor traffic conditions and cruise schedules to guarantee on-time arrival and seamless pickups. A cruise terminal limo service provides private, professional transportation to cruise ports with guaranteed punctuality and comfort.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Premium Transportation to New York Cruise Ports" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Why Choose Our Cruise Terminal Limo Service" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Why Choose Our Cruise Terminal Limo and Car Service?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Cruise travel requires precise timing and dependable transportation. Our cruise terminal transportation service is designed to eliminate stress before and after your voyage.
        </p>
        
        <p className="text-base sm:text-lg mb-2 sm:mb-2 leading-relaxed font-semibold text-gray-900">
          Key Benefits:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">🚘</span>
            <span><strong>Luxury Vehicles:</strong> Sedans, SUVs, stretch limos, and Sprinter vans</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">🧳</span>
            <span><strong>Luggage Assistance:</strong> Ideal for cruise travelers with multiple bags</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">🕒</span>
            <span><strong>On-Time Guarantee:</strong> Never miss your ship's departure</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">🧑‍✈️</span>
            <span><strong>Professional Chauffeurs:</strong> Licensed, experienced, and courteous</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">💼</span>
            <span><strong>Private & Comfortable:</strong> No shared rides or waiting</span>
          </li>
        </ul>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Transportation to New York Cruise Port for All Travelers
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Our cruise terminal transportation is perfect for:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Couples and families</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Groups and cruise parties</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Luxury cruise travelers</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Seniors and international guests</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Hotel-to-port and airport-to-port transfers</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Whether you're traveling from a home, hotel, airport, or another city, we tailor your ride to your itinerary.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Transportation to New York Cruise Port for All Travelers" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Airport to Cruise Terminal Transportation" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Airport to Cruise Terminal Transportation
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          We provide seamless transfers from:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>JFK Airport</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>LaGuardia Airport (LGA)</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Newark Liberty International Airport (EWR)</strong></span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our cruise terminal limo and car service ensures timely airport pickups and direct transportation to your cruise port without delays.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Fleet Options for Cruise Terminal Transportation
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Choose the right vehicle for your cruise trip:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Luxury Sedans:</strong> Ideal for solo travelers or couples</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Black SUVs:</strong> Perfect for families and extra luggage</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Stretch Limousines:</strong> Stylish option for cruise celebrations</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Mercedes Sprinter Vans:</strong> Best for groups and cruise parties</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          All vehicles are clean, insured, climate-controlled, and professionally maintained.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Fleet Options for Cruise Terminal Transportation" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="How Our Cruise Terminal Transportation Works" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          How Our Cruise Terminal Transportation Works
        </h2>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Reserve Your Ride:</strong> Share pickup location, cruise port, and time</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Chauffeur Arrival:</strong> On-time pickup with luggage assistance</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Comfortable Transfer:</strong> Smooth ride to the cruise terminal</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Terminal Drop-Off:</strong> Direct drop-off at cruise ship entrance</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Return Pickup Available:</strong> Post-cruise transportation on request</span>
          </li>
        </ul>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Book Your Cruise Terminal Limo and Car Service Today
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Start and end your cruise the right way with our premium cruise terminal limo and car service. From luxury vehicles to punctual service, we make transportation to New York cruise ports simple, comfortable, and reliable.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Book Your Cruise Terminal Limo and Car Service Today" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>
    
    <FAQ3/>

    <Footer/>
    </>
  );
}

export default CruiseTransfers;
